import request from "@/utils/request";

// 查询执行标准净水厂详情
export function queryPurificationStandardByType(type) {
  return request({
    url: `/opStandardWaterOutClean/getInfoByType/${type}`,
    method: "get",
  });
}

// 新增或编辑净水厂出水标准
export function adjustPurificationStandard(data) {
  return request({
    url: "/opStandardWaterOutClean/saveOrUpdateOpStandardWaterOutClean",
    method: "post",
    data,
  });
}

// 查询供水厂标准详情
export function querySupplyStandard() {
  return request({
    url: `/opStandardWaterOutSupply/getSupply`,
    method: "get",
  });
}

// 新增或修改供水厂出水标准
export function adjustSupplyStandard(data) {
  return request({
    url: "/opStandardWaterOutSupply/saveOrUpdateOpStandardWaterOutSupply",
    method: "post",
    data,
  });
}
